import { actions } from './actions';

export const userModule = {
  actions,
};

export interface IAccountInfo {
  // 法人名
  company_name: string | null;
  // 会社HP（URL）
  company_url: string | null;
  // 設立年月日
  company_foundation_date: Date | string | null;
  // 業種
  company_industry_category1: string | null;
  company_industry_detail1: string | null;
  company_industry_category2: string | null;
  company_industry_detail2: string | null;
  company_industry_category3: string | null;
  company_industry_detail3: string | null;
  // 事業フェーズ
  company_growth_phase: string | null;
  // 担当者指名
  user_last_name: string | null;
  user_first_name: string | null;
  // 担当者肩書
  user_title: string | null;
  // メールアドレス
  user_email: string | null;
}